import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatDialog,
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { EventService } from "src/_services/event.service";
import { Router } from "@angular/router";
import * as moment from "moment";
@Component({
  selector: "app-event-mapping",
  templateUrl: "./event-mapping.component.html",
  styleUrls: ["./event-mapping.component.scss"],
})
export class EventMappingComponent implements OnInit {
  DisplayedColumns: string[] = ["BetFairEvents", "SportRadaeEvents", "Action"];
  eventsData = new MatTableDataSource<any>();
  sportsData = [];
  sportId: string = "4";
  matchedSportsData = [];
  unMatchedSportsData = [];
  allSportsData = [];
  selectedSportRadarEvent = "all";
  selectedDate: any = {
    startDate: moment(new Date()).format("DD-MM-YYYY"),
    endDate: moment(new Date()).format("DD-MM-YYYY"),
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  constructor(
    private eventService: EventService,
    public dialog: MatDialog,
    private router: Router,
    private appService: AppService
  ) {}

  async ngOnInit() {
    await this.getOurMatchedSports(this.sportId);
    this.getOurSports(this.sportId);
    this.sportsData = [
      { SportId: "4", SportName: "cricket" },
      { SportId: "1", SportName: "soccer" },
      { SportId: "2", SportName: "tennis" },
    ];
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  onChangeSports = (sid) => {
    this.sportId = sid;
    this.getOurMatchedSports(this.sportId);
    this.getOurSports(this.sportId);
  };
  onDateChangeHandler(event: MatDatepickerInputEvent<Date>) {
    this.selectedDate = event;
    this.getOurMatchedSports(this.sportId);
    this.getOurSports(this.sportId);
  }
  getOurMatchedSports(sid) {
    try {
      this.eventService
        .getOurMatchedSports(sid, this.selectedDate)
        .subscribe((res) => {
          let data = [];
          if (res[0].status === "RS_OK") {
            data = res[0].matchedSports;
          }
          if (res[1].status === "RS_OK") {
            data = data.concat(res[1].matchedSports);
          }
          this.eventsData = new MatTableDataSource<any>(data);
          this.eventsData.paginator = this.paginator;
        });
    } catch (err) {}
  }

  getOurSports = (sid) => {
    try {
      this.eventService
        .getOurSports(sid, this.selectedDate)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.allSportsData = res.matchedSports;
          }
        });
    } catch (err) {}
  };
  onChangeSportRadraEvent = (eid) => {
    this.selectedSportRadarEvent = eid;
  };
  handleSave = (data: any) => {
    if (this.selectedSportRadarEvent === "all") {
      this.appService.openErrorBar("Please Select Sport Radar Event");
    } else {
      let postData = {
        eventId: data.eventId,
        srCompetitionId: data.srCompetitionId,
        srCompetitionName: data.srCompetitionName,
        srEventId: this.selectedSportRadarEvent,
        srEventName: data.srEventName,
      };
      try {
        this.eventService.updateSportCard(postData).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.selectedSportRadarEvent = "all";
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
      } catch (err) {}
    }
  };
}
